document.addEventListener("DOMContentLoaded", function () {
	const searchInput = document.getElementById("event-search-input");
	const searchButton = document.getElementById("event-search-button");
	const categoryFilter = document.getElementById("event-category-filter");
	const ageFilter = document.getElementById("event-age-filter");
	const startDateFilter = document.getElementById("event-start-date-filter");
	const endDateFilter = document.getElementById("event-end-date-filter");
	const eventItems = document.querySelectorAll(".events-grid-item");
	const paginationContainer = document.querySelector(".wp-block-events-pagination");

	const ITEMS_PER_PAGE = 12;
	let currentPage = 1;
	let currentMatchedItems = [];

	// Check URL and pre-select category if present
	function selectCategoryFromURL() {
		if (!categoryFilter) return;

		const urlPath = window.location.pathname;
		const pathSegments = urlPath
			.split("/")
			.filter((segment) => segment.length > 0);
		const lastSegment = pathSegments[pathSegments.length - 1];

		if (!lastSegment) return;

		const options = categoryFilter.querySelectorAll("option");
		options.forEach((option) => {
			const optionValue = option.value;
			const sanitizedSegment = lastSegment.toLowerCase();
			if (optionValue && optionValue.toLowerCase() === sanitizedSegment) {
				categoryFilter.value = optionValue;
			}
		});
	}

	// Evaluate which items match the current filters and hand off to applyPage()
	function filterEvents() {
		const searchTerm = searchInput.value.toLowerCase();
		const selectedCategory = categoryFilter ? categoryFilter.value : "";
		const selectedAge = ageFilter ? ageFilter.value : "";
		const startDate = startDateFilter ? startDateFilter.value : "";
		const endDate = endDateFilter ? endDateFilter.value : "";

		const matched = [];

		eventItems.forEach((item) => {
			const dataTitle = item.getAttribute("data-title") || "";
			const dataLocation = item.getAttribute("data-location") || "";
			const dataCategory = item.getAttribute("data-category") || "";
			const dataAge = item.getAttribute("data-age") || "";
			const dataDates = item.getAttribute("data-dates") || "[]";
			const isRecurring = item.getAttribute("data-is-recurring") === "1";

			const titleElement =
				item.querySelector(".wp-block-heading") ||
				item.querySelector("h1, h2, h3, h4, h5, h6") ||
				item.querySelector("[class*='title']");
			const visibleTitle = titleElement
				? titleElement.textContent.toLowerCase()
				: "";

			const searchWithDashes = searchTerm.replace(/\s+/g, "-");
			const searchWithSpaces = searchTerm.replace(/-+/g, " ");

			let matchesSearch = true;
			let matchesCategory = true;
			let matchesAge = true;
			let matchesDateRange = true;

			if (searchTerm !== "") {
				matchesSearch =
					dataTitle.includes(searchTerm) ||
					dataTitle.includes(searchWithDashes) ||
					visibleTitle.includes(searchTerm) ||
					visibleTitle.includes(searchWithSpaces) ||
					dataLocation.includes(searchTerm) ||
					dataLocation.includes(searchWithSpaces);
			}

			if (selectedCategory !== "") {
				const formattedCategory = sanitizeTitle(selectedCategory);
				matchesCategory = dataCategory === formattedCategory;
			}

			if (selectedAge !== "") {
				const formattedAge = sanitizeTitle(selectedAge);
				matchesAge = dataAge === formattedAge;
			}

			if (startDate !== "" || endDate !== "") {
				matchesDateRange = false;

				try {
					const eventDates = JSON.parse(dataDates);

					if (eventDates.length > 0) {
						if (isRecurring && eventDates.length >= 2) {
							const eventStart = new Date(eventDates[0]);
							const eventEnd = new Date(eventDates[1]);
							const filterStart = startDate ? new Date(startDate) : null;
							const filterEnd = endDate ? new Date(endDate) : null;

							if (filterStart && filterEnd) {
								matchesDateRange =
									eventStart <= filterEnd && eventEnd >= filterStart;
							} else if (filterStart) {
								matchesDateRange = eventEnd >= filterStart;
							} else if (filterEnd) {
								matchesDateRange = eventStart <= filterEnd;
							}
						} else if (isRecurring && eventDates.length === 1) {
							const eventStart = new Date(eventDates[0]);
							const filterStart = startDate ? new Date(startDate) : null;
							const filterEnd = endDate ? new Date(endDate) : null;

							if (filterStart && filterEnd) {
								matchesDateRange = eventStart <= filterEnd;
							} else if (filterStart) {
								matchesDateRange = true;
							} else if (filterEnd) {
								matchesDateRange = eventStart <= filterEnd;
							}
						} else {
							for (let dateStr of eventDates) {
								const eventDate = new Date(dateStr);
								let dateInRange = true;

								if (startDate) {
									const filterStart = new Date(startDate);
									if (eventDate < filterStart) {
										dateInRange = false;
									}
								}

								if (endDate && dateInRange) {
									const filterEnd = new Date(endDate);
									if (eventDate > filterEnd) {
										dateInRange = false;
									}
								}

								if (dateInRange) {
									matchesDateRange = true;
									break;
								}
							}
						}
					} else if (isRecurring) {
						matchesDateRange = true;
					}
				} catch (e) {
					console.error("Error parsing event dates:", e);
					if (isRecurring) {
						matchesDateRange = true;
					}
				}
			}

			// Hide everything — applyPage() will reveal the current page's slice
			item.style.display = "none";

			if (matchesSearch && matchesCategory && matchesAge && matchesDateRange) {
				matched.push(item);
			}
		});

		currentMatchedItems = matched;
		currentPage = 1;
		applyPage();
	}

	// Show only the items belonging to currentPage from currentMatchedItems
	function applyPage() {
		eventItems.forEach((item) => {
			item.style.display = "none";
		});

		const total = currentMatchedItems.length;
		const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
		const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, total);

		for (let i = startIndex; i < endIndex; i++) {
			currentMatchedItems[i].style.display = "flex";
		}

		updatePagination(total, currentPage);
	}

	// Navigate to a specific page without re-filtering
	function goToPage(page) {
		currentPage = page;
		applyPage();

		const block = document.querySelector(".wp-block-events");
		if (block) {
			block.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	}

	// Rebuild pagination controls
	function updatePagination(total, page) {
		if (!paginationContainer) return;

		const totalPages = Math.ceil(total / ITEMS_PER_PAGE);

		if (totalPages <= 1) {
			paginationContainer.style.display = "none";
			paginationContainer.innerHTML = "";
			return;
		}

		paginationContainer.style.display = "flex";

		const maxButtons = 10;
		let startPage = Math.max(1, page - Math.floor(maxButtons / 2));
		let endPage = Math.min(totalPages, startPage + maxButtons - 1);

		if (endPage - startPage < maxButtons - 1) {
			startPage = Math.max(1, endPage - maxButtons + 1);
		}

		let html = `
			<button class="pagination-prev" data-page="${page - 1}" ${page === 1 ? "disabled" : ""}>Previous</button>
			<div class="pagination-numbers">
		`;

		for (let i = startPage; i <= endPage; i++) {
			const activeClass = i === page ? "active" : "";
			html += `<button class="pagination-number ${activeClass}" data-page="${i}">${i}</button>`;
		}

		if (endPage < totalPages) {
			html += '<span class="pagination-ellipsis">...</span>';
		}

		html += `
			</div>
			<button class="pagination-next" data-page="${page + 1}" ${page === totalPages ? "disabled" : ""}>Next</button>
		`;

		paginationContainer.innerHTML = html;

		paginationContainer.querySelectorAll("button").forEach((button) => {
			button.addEventListener("click", function () {
				if (this.disabled) return;
				const targetPage = parseInt(this.getAttribute("data-page"), 10);
				goToPage(targetPage);
			});
		});
	}

	// Helper function to mimic WordPress's sanitize_title function
	function sanitizeTitle(text) {
		return text
			.toLowerCase()
			.replace(/\s+/g, "-")
			.replace(/[^a-z0-9-]/g, "")
			.replace(/-+/g, "-")
			.replace(/^-|-$/g, "");
	}

	// Add event listeners
	if (searchButton) {
		searchButton.addEventListener("click", filterEvents);
	}

	if (searchInput) {
		searchInput.addEventListener("input", filterEvents);
		searchInput.addEventListener("keypress", function (event) {
			if (event.key === "Enter") {
				event.preventDefault();
				filterEvents();
			}
		});
	}

	if (categoryFilter) {
		categoryFilter.addEventListener("change", filterEvents);
	}

	if (ageFilter) {
		ageFilter.addEventListener("change", filterEvents);
	}

	if (startDateFilter) {
		startDateFilter.addEventListener("change", filterEvents);
	}

	if (endDateFilter) {
		endDateFilter.addEventListener("change", filterEvents);
	}

	// Initialize
	selectCategoryFromURL();
	filterEvents();
});
